import type { TOC } from '@ember/component/template-only';
import { array } from '@ember/helper';
import { on } from '@ember/modifier';

import joinClasses from 'webapp/helpers/join-classes';
import safeStyle from 'webapp/helpers/safe-style';
import onWindowEvents from 'webapp/modifiers/on-window-events';
import CommonUiIcon from 'webapp/components/common/ui-icon';

import ReportUIHelper from 'webapp/models-custom/report-ui-helper';

interface ReportsViewerNavigationTogglerComponentInterface {
	Element: HTMLDivElement;
	Args: {
		reportUIHelper: ReportUIHelper;
		color: string;
	};
}

const ReportsViewerNavigationTogglerComponent: TOC<ReportsViewerNavigationTogglerComponentInterface> =
	<template>
		<div
			class={{joinClasses
				(array "report-nav-toggler" (unless @reportUIHelper.isSlideNavOpen "collapsed"))
			}}
			style={{safeStyle @color property="background-color"}}
			role="button"
			{{on "click" @reportUIHelper.toggleSlideNav}}
			{{onWindowEvents @reportUIHelper.checkViewMode "resize" 200}}
		>
			<CommonUiIcon @name={{@reportUIHelper.slideSwitchToggleIconName}} @size="sm" />
		</div>
	</template>;

export default ReportsViewerNavigationTogglerComponent;
